var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDonut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1 17.4C28.7166 20.7994 27.0663 23.9294 24.4779 26.1661C21.8895 28.4028 18.5533 29.582 15.1342 29.4684C11.7152 29.3549 8.4646 27.957 6.03033 25.5535C3.59607 23.1499 2.15699 19.9173 2 16.5C2.01697 15.7962 2.08381 15.0944 2.20001 14.4C2.26271 15.4025 2.66654 16.3534 3.34439 17.0947C4.02224 17.8359 4.93329 18.3229 5.92621 18.4748C6.91913 18.6267 7.9341 18.4342 8.80252 17.9294C9.67094 17.4247 10.3405 16.638 10.7 15.7C10.8112 15.4818 10.8791 15.2441 10.9 15C11.2097 13.895 11.8974 12.9337 12.8432 12.2838C13.7891 11.6339 14.933 11.3366 16.0756 11.4437C17.2182 11.5508 18.2869 12.0555 19.0955 12.8699C19.904 13.6843 20.4011 14.7567 20.5 15.9V16.8C20.6247 17.8692 21.1458 18.8527 21.9605 19.5563C22.7751 20.2599 23.8241 20.6323 24.9 20.6C25.8562 20.6096 26.7884 20.3001 27.549 19.7206C28.3097 19.141 28.8554 18.3245 29.1 17.4Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5001 16.5V16.8C20.4484 18.0646 19.9095 19.2602 18.9961 20.1363C18.0827 21.0124 16.8657 21.5011 15.6001 21.5C14.274 21.5 13.0022 20.9732 12.0645 20.0356C11.1269 19.0979 10.6001 17.8261 10.6001 16.5C10.6001 16.2 10.7001 16 10.7001 15.7C10.8113 15.4818 10.8792 15.2441 10.9001 15C11.2098 13.895 11.8975 12.9337 12.8433 12.2838C13.7892 11.6339 14.9331 11.3366 16.0757 11.4437C17.2183 11.5508 18.287 12.0555 19.0956 12.8699C19.9041 13.6843 20.4012 14.7567 20.5001 15.9V16.5Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1002 16.5V17.4C28.8556 18.3245 28.3098 19.141 27.5492 19.7206C26.7885 20.3001 25.8564 20.6096 24.9002 20.6C23.8243 20.6323 22.7753 20.2599 21.9607 19.5563C21.146 18.8527 20.6249 17.8692 20.5002 16.8V15.9C20.4013 14.7567 19.9042 13.6843 19.0957 12.8699C18.2871 12.0555 17.2184 11.5508 16.0758 11.4436C14.9332 11.3365 13.7892 11.6338 12.8434 12.2838C11.8976 12.9337 11.2099 13.895 10.9002 15C10.8002 15.2 10.8002 15.5 10.7002 15.7C10.3407 16.6379 9.67112 17.4246 8.8027 17.9294C7.93428 18.4342 6.91931 18.6266 5.92639 18.4748C4.93348 18.3229 4.02242 17.8359 3.34457 17.0947C2.66672 16.3534 2.2629 15.4025 2.2002 14.4C2.30825 13.6546 2.47544 12.9189 2.7002 12.2C3.63249 9.51913 5.37441 7.19401 7.68527 5.54594C9.99614 3.89788 12.7619 3.00828 15.6002 3.00002C18.8724 2.99504 22.0349 4.17866 24.4998 6.3308C26.9646 8.48293 28.5639 11.457 29.0002 14.7C29.0832 15.2962 29.1166 15.8983 29.1002 16.5Z",
    fill: "url(#paint0_linear_20_81)",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8999 14.2L8.09991 12.8",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6998 9.90002L10.2998 8.80002",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6998 10.2L21.2998 9.10001",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7002 8.10001L16.8002 6.70001",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2998 15.2L25.4998 13.8",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_81",
    x1: 8,
    y1: 25,
    x2: 9.04277,
    y2: 2.56052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7DAC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0440"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonut);
export default __webpack_public_path__ + "static/media/donut.5545e6d1bb61367c4eea4fb0fb8474a8.svg";
export { ForwardRef as ReactComponent };